import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
/*
Ver documentación en: https://vuex.vuejs.org/api/#mutations
*/

const UsersVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "AccountUsers/v1.0/",
    $_users: [],
    $_currentUser: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allUsers: (state) => state.$_users,
    currentUser: (state) => state.$_currentUser,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initUser({ commit }) {
      var user = {
        id: "",
        identificationNumber: "",
        names: "",
        surnames: "",
        userName: "",
        email: "",
        phoneNumber: "",
        domain: "",
        password: "",
        profileId: null,
        zoneId: 0,
        active: false,
        applications: {
          id: 0
        }
      };

      commit("SET_USER", user);
    },
    clearUsers({ commit }) {
      commit("SET_USERS", []);
    },
    setUser({ commit }, user) {
      commit("SET_USER", user);
    },
    async getUsers({ commit, dispatch, state, rootGetters }) {
      var authUrl = rootGetters.authUrl;
      var actionLink =
        authUrl +
        state.$_moduleApiPath +
        "GetUserAccountByApplicationIdAsync" +
        ":" +
        rootGetters.applicationId;
      var axiosConfig = rootGetters.authaxiosConfig;

      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_USERS", response.data.data);
      } catch (error) {
        console.log(error);
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    // async getUser({ commit, state, rootGetters }, identificationNumber) {
    //   var authUrl = rootGetters.authUrl;
    //   var actionLink =
    //     authUrl + state.$_moduleApiPath + "/" + identificationNumber;
    //   try {
    //     const response = await axios.get(actionLink);
    //     commit("SET_USER", response.data);
    //   } catch (error) {
    //     commit("SET_ERROR", error);
    //   }
    // },
    async createUser({ commit, dispatch, state, rootGetters }, user) {
      var authUrl = rootGetters.authUrl;
      var actionLink = authUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.authaxiosConfig;
      if (!user.domain)
        actionLink = actionLink + "CreateApplicationUserAccountAsync";
      else actionLink = actionLink + "CreateActiveDirectoryUserAccountAsync";

      if (user.zoneId == 0) user.zoneId = null;
      try {
        user.applications.id = rootGetters.applicationId;
        const response = await axios.post(actionLink, user, axiosConfig);
        user.id = response.data.id;
        commit("SET_USER", user);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateUser({ commit, dispatch, state, rootGetters }, data) {
      var authUrl = rootGetters.authUrl;
      var actionLink = authUrl + state.$_moduleApiPath + "UpdateAccountAsync";
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        data.user.applications = { id: rootGetters.applicationId };
        if (data.user.zoneId == 0) data.user.zoneId = null;
        const response = await axios.put(actionLink, data.user, axiosConfig);
        data.user.id = response.data.id;
        commit("SET_USER", data.user);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async deleteUser({ commit, dispatch, state, rootGetters }, data) {
      var authUrl = rootGetters.authUrl;
      var actionLink = authUrl + state.$_moduleApiPath + "DeleteAccountAsync";
      var axiosConfig = rootGetters.authaxiosConfig;
      var $_axiosConfig = JSON.parse(JSON.stringify(axiosConfig));
      $_axiosConfig.data = data.user;
      try {
        await axios.delete(actionLink, $_axiosConfig);
        // data.user = response.data;

        commit("SET_USER", data.user);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_USERS(state, value) {
      state.$_users = value;
    },
    SET_USER(state, value) {
      state.$_currentUser = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default UsersVuexModule;
